import { Plus } from 'lucide-react';
import { Button } from '@monksflow/monks-ui';
import { SearchInput } from '@/shared/ui';
import { useTranslation } from 'react-i18next';

interface SessionsToolbarProps {
  searchValue: string;
  onSearchChange: (value: string) => void;
  onNewSession: () => void;
}

/**
 * Toolbar for the Sessions page matching Beat UI CardHeader.
 *
 * Layout: justify-between, padding 16px, search 320px fixed.
 */
export function SessionsToolbar({
  searchValue,
  onSearchChange,
  onNewSession,
}: SessionsToolbarProps) {
  const { t } = useTranslation('chats');
  const searchLabel = t('sessions.sessionsToolbar.searchSessionsLabel');

  return (
    <div data-testid="sessions-toolbar" className="flex items-center justify-between p-section">
      <SearchInput
        value={searchValue}
        onChange={onSearchChange}
        placeholder={t('sessions.sessionsToolbar.searchSessions')}
        aria-label={searchLabel}
        size="lg"
        className="w-80"
      />

      <Button size="lg" onClick={onNewSession}>
        <Plus className="size-4" />
        {t('sessions.sessionsToolbar.newSession')}
      </Button>
    </div>
  );
}
